import React, { useRef } from 'react';

function Home({ handleMouseMove, handleMouseLeave }) {
  const elementRef = useRef(null);

  return (
    <section id="home" className="relative h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-gray-900 via-gray-950 to-gray-950"></div>
      <div className="absolute top-20 left-10 w-72 h-72 rounded-full bg-yellow-600/5 blur-3xl"></div>
      <div className="absolute bottom-20 right-10 w-96 h-96 rounded-full bg-yellow-600/5 blur-3xl"></div>
      
      <div className="relative z-10 text-center max-w-4xl luxury-container">
        <h1 
          className="text-8xl font-black mb-6 tracking-tighter transform-gpu transition-transform duration-75 cursor-pointer hero-glow"
          onMouseMove={(e) => handleMouseMove(e, e.currentTarget)}
          onMouseLeave={(e) => handleMouseLeave(e?.currentTarget)}
        >
          TIMELESS ELEGANCE
        </h1>
        <p className="text-2xl mb-12 text-yellow-400/80 font-light tracking-widest hover-glow">
          Discover Our Exquisite Collection of Fine Jewelry
        </p>
        <a 
          href="/collections"
          className="inline-block bg-gradient-to-r from-yellow-600 to-yellow-700 hover:from-yellow-500 hover:to-yellow-600 text-gray-900 px-10 py-4 rounded-sm font-bold text-lg tracking-widest transform-gpu transition-transform duration-75 cursor-pointer depth-effect"
          onMouseMove={(e) => handleMouseMove(e, e.currentTarget)}
          onMouseLeave={(e) => handleMouseLeave(e?.currentTarget)}
        >
          EXPLORE NOW
        </a>
      </div>
    </section>
  );
}

export default Home;
